import { addUnlockSizeRatioMediaElementAction as addUnlockSizeRatioMediaElementOperation } from 'editor/src/store/editor/slice';

export default addUnlockSizeRatioMediaElementOperation;
